import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { actions as virtualCardActions } from '@ott/shared-virtual-card-logic/main';
import Tooltip from '@ott/tooltip';

import { useTimeoutTimer } from './useTimeoutTimer';

import styles from './VirtualCardCodeButton.scss';

const TOOLTIP_TIMEOUT = 3000;
const CVC_BLOCK_SECONDS = 30;

export const VirtualCardCodeButton = () => {
  const dispatch = useDispatch();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const { secondsLeft, restartTimer } = useTimeoutTimer(CVC_BLOCK_SECONDS);

  const getVirtualCardCVVCode = useCallback(() => {
    setIsTooltipVisible(true);
    restartTimer();

    setTimeout(() => {
      setIsTooltipVisible(false);
    }, TOOLTIP_TIMEOUT);

    dispatch(virtualCardActions.getVerificationCode());
  }, [dispatch, restartTimer]);

  return (
    <div className={styles.container}>
      <Tooltip
        isVisible={isTooltipVisible}
        specificLocator="virtual-card-sms-button"
        content={<span>CVC-код отправлен в SMS</span>}
      >
        {secondsLeft ? (
          <span className={styles.cvvResendText} data-locator="virtual-card-timeout-cvc-text">
            Повторная отправка через {secondsLeft} сек
          </span>
        ) : (
          <button className={styles.cvvButton} type="button" onClick={getVirtualCardCVVCode}>
            Получить CVC-код в SMS
          </button>
        )}
      </Tooltip>
    </div>
  );
};
